/**
 * @desc 修改调拨单信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationMasterUpdateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/updateAllocationMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
